import { render, staticRenderFns } from "./ChangeImprovementStatus.vue?vue&type=template&id=1c8fb292&"
import script from "./ChangeImprovementStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeImprovementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports